module.exports = __webpack_public_path__ + "static/media/venuemap.9a0f90ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/venuemap.png
// module id = 33
// module chunks = 0